import React, { useCallback, useRef } from 'react';
import { useAppHistory } from './router';
import logoDark from '@/images/logo-dark.svg';
import logoLight from '@/images/logo-light.svg';

export const HomeButton: React.FC<{ onlyIcon?: boolean }> = ({ onlyIcon }) => {
  const history = useAppHistory();
  const isProcessingRef = useRef(false);
  const lastEventTypeRef = useRef<string | null>(null);

  const handleHomeClick = useCallback(
    (e: React.TouchEvent<HTMLButtonElement> | React.MouseEvent<HTMLButtonElement>) => {
      e.preventDefault();
      if (isProcessingRef.current) return;

      isProcessingRef.current = true;
      lastEventTypeRef.current = e.type;

      try {
        window.dispatchEvent(new Event('mastodon:home-suggested-feed'));
        history.replace('/home');
      } finally {
        setTimeout(() => {
          isProcessingRef.current = false;
          lastEventTypeRef.current = null;
        }, 100);
      }
    },
    [history]
  );

  const isLight = document.body?.classList.contains('theme-mastodon-light') || 
                  (document.body?.classList.contains('theme-system') && window.matchMedia('(prefers-color-scheme: light)').matches);
  const logo = isLight ? logoDark : logoLight;

  return (
    <button
      onClick={handleHomeClick}
      className='column-header__home-button'
      aria-label='Home'
      style={{ touchAction: 'manipulation', userSelect: 'none' }}
    >
      <img className='mobile--logo' src={logo} alt='' />
    </button>
  );
};
